import { ReactNode } from "react";
import { Invisible } from "../invisible";
import { cn } from "../../utils/class-names";

interface SkeletonWrapperProps {
  className?: string;
  children?: ReactNode;
}

export function SkeletonWrapper({
  className,
  children,
}: SkeletonWrapperProps): JSX.Element {
  return (
    <div className={cn("rounded-lg bg-shale-800", className)}>
      <Invisible>{children}</Invisible>
    </div>
  );
}
